var _regeneratorRuntime = require("/home/runner/work/unitpedia/unitpedia/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/runner/work/unitpedia/unitpedia/node_modules/@babel/runtime/helpers/asyncToGenerator");

/**
 * send
 *
 * @name send
 * @function send packet to worker and create a job
 * @access public
 */
module.exports = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(worker, packet) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            worker.postMessage(packet);

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();